export default __webpack_public_path__ + "static/prodideFeedback.14ab4ccfc9cd5f02be725058ffba267a.png";